import { useMemo } from "react";

import {
    getBasicFeatureset,
    getChatFeatureset,
    getChatWithImagesFeatureset,
    getStandardFeatureset,
} from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type ExtensionProviderProps } from "commonComponents/btWrappers/editor/core/extensions/ExtensionProvider.types";

/**
 * This component exists to help lazy load the extensions (the extensions have a large bundle size).
 * Simply passdown the configuration and event bindings that you need and this component will
 * return you the array of extensions to pass into the editor. Ask architecture/frontend before
 * using this component. BTEditor and BTEditorBasic should probably be used instead to handle this.
 */
export default function ExtensionProvider({
    featureSet,
    extensionConfig,
    children,
}: ExtensionProviderProps) {
    const extensions = useMemo(() => {
        switch (featureSet) {
            case "basic":
                return getBasicFeatureset(extensionConfig ?? {});
            case "chat":
                return getChatFeatureset(extensionConfig ?? {});
            case "chatWithImages":
                return getChatWithImagesFeatureset(extensionConfig ?? {});
            case "standard":
                return getStandardFeatureset(extensionConfig ?? {});
        }
    }, [featureSet, extensionConfig]);

    return children(extensions);
}
